import { addDays, isBefore, parse, startOfToday } from 'date-fns';
import { Turn } from '../models/types';

export function getEarliestBookableDate(): Date {
    return addDays(startOfToday(), 1);
}

export function isDateBookable(date: Date): boolean {
    return !isBefore(date, getEarliestBookableDate());
}

export function isTurnBookable(turn: Turn): boolean {
    const bookingDate = parse(turn.booking_date, 'yyyy-MM-dd', new Date());
    return isDateBookable(bookingDate);
}
